import { Spin } from 'antd';
import React, { Suspense } from 'react';
import { AuthenticationWrap } from './overview/style';
import lightBg from '../../static/img/admin-bg-light.png';
import logo from '../../static/img/admin-bg-light.png';

const AuthLayout = (WraperContent) => {
  const WrappedComponent = function () {
    return (
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        <AuthenticationWrap style={{ backgroundImage: `url("${lightBg}")` }}>
          <div className="ninjadash-authentication-wrap">
            <div className="ninjadash-authentication-brand">
              <img height="29" src={logo} alt="" />
            </div>
            <WraperContent />
          </div>
        </AuthenticationWrap>
      </Suspense>
    );
  };

  // Assign a display name for easier debugging
  WrappedComponent.displayName = `AuthLayout(${WraperContent.displayName || WraperContent.name || 'Component'})`;

  return WrappedComponent;
};

export default AuthLayout;
